import React, { memo } from 'react';
import SimpleModal from '../../../SimpleModal/SimpleModal';
import JsonEditor from '../../../JsonEditor';
import getVisualizationSettingsSchema from '../schemas/visualizationSchema';

const VisualizationSettingsModal = memo((properties) => {
  const { onCloseModal, visLength, onSubmit } = properties;
  const schema = getVisualizationSettingsSchema(visLength);

  return (
    <SimpleModal
      onClose={onCloseModal}
      title="Settings"
    >
      <div>
        <JsonEditor
          schema={schema}
          onFormSubmit={({ formData: form }) => onSubmit(form)}
          saveButtonText={'Save'}
          initialEditMode={true}
          showEditButton={false}
          cancelCallback={onCloseModal}
        />
      </div>
    </SimpleModal>
  );
});

export default VisualizationSettingsModal;
